module.exports = __webpack_public_path__ + "static/assets/50ea2908c24cdd518746077f419628ee.png";